import {
  OnInit,
  EventEmitter,
  Output,
  Input,
  Directive,
  OnDestroy,
  AfterViewChecked,
  AfterViewInit,
  HostBinding,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { takeUntil } from "rxjs/operators";
import { SelectorService } from "./selector.service";
import { Subject } from "rxjs";
@Directive()
export abstract class BaseControlComponent<T> implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit {
  get isValid() {
    return this.group.controls[this.name].valid;
  }
  @Input() valueFieldName: string;
  @Input() textFieldName: string;
  @Input() apiName: string;
  @Input() systemName: string;
  @Input() category: string;
  @Input() tabOrder?: number = 0;
  @Input() textColumnsName: string;
  @Input() columnsTitleName: string;
  @Input() defaultHeight: number = 40;
  @Output() onEnter: EventEmitter<any> = new EventEmitter<any>();
  ngUnsubscribe = new Subject<void>();
  _pattern: string;
  @Output() valueChange = new EventEmitter<any>();
  @Output() valueChangeWithName = new EventEmitter<any>();
  @Output() valueChangeByApiName = new EventEmitter<any>();
  @Input() label: string;
  @Input() name: string;
  @Input() id: string;
  @Input() required: boolean = false;
  @Input() hidden: boolean = false;
  @Input() disabled: boolean = false;
  @Input() textType: string = "text";
  @Input() isDecimal: boolean = false;
  @Input() minLength: string;
  @Input() maxLength: string;
  @Input() min: number;
  @Input() max: number;
  @Input() placeholder: string = "";
  @Input() multiple: boolean = false;
  @Input() isNullable: boolean = false;
  @Input() patternKey: string;
  @HostBinding("style.width.px") width: Number;
  @HostBinding("style.height.px") height: Number;
  @HostBinding("style.margin-bottom.px") marginbottom: Number = 15;
  get f() {
    return this.group?.controls;
  }
  @Input() userClass: string;
  @Input() group: UntypedFormGroup;
  //private  _formBuilder: FormBuilder;
  public patterns = {
    email: "([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+",
    url: "(https?)://[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]",
    mobile: "^[0-0][9-9]\\d{9}",
    telephone: "^[1-9]\\d{3,7}",
    nationalcode: "^[0-9]\\d{9}",
    lockserial: "^d{4}-d{4}-d{4}",
    number: "^\\d+$",
    minMax: "^$|^([0-9]|[1-9][0-9]|[1][0][0])?",
  };
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {}
  ngAfterViewInit(): void {}

  ngAfterViewChecked(): void {}

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }
  ngOnInit() {
    if (this.name && this.group?.controls && this.group?.controls[this.name]) {
      this.group?.controls[this.name]?.valueChanges?.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x && this.group?.controls) {
          this.group?.controls[this.name]?.markAllAsTouched();
          this.cd.markForCheck();
        }
      });
    }
    this.selectorService.onSubmited.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && this.group?.controls && this.name) {
        this.group?.controls[this.name]?.markAllAsTouched();
        this.height = this.defaultHeight;
        this.marginbottom = this.defaultHeight - 25;
        this.cd.markForCheck();
      }
    });
    this.defaultHeight = this.defaultHeight ?? 40;
    this.height = this.defaultHeight;
    this.marginbottom = this.defaultHeight - 25;
    this.cd.markForCheck();
  }

  onChange(value: any) {
    this.valueChange.emit(value);
    this.valueChangeWithName.emit({ name: this.name, value: value });
    this.valueChangeByApiName.emit({ data: value, apiName: this.apiName, KeyName: this.name });
    this.cd.markForCheck();
  }
  formControl() {
    return this.group.get(this.name);
  }
}
